export default __webpack_public_path__ + "static/media/blue-ribbon.b0260f17.png";